export const DEFAULT_TABLE_PAGE_SIZE = 8;
